import { detectDeviceLocale, normalizeLocale } from './locales';
import enUS from '../locales/en-US';
import itIT from '../locales/it-IT';
import esES from '../locales/es-ES';

const DICTIONARIES = Object.freeze({
  'en-US': enUS,
  'it-IT': itIT,
  'es-ES': esES,
});

export const resolveNestedValue = (object, key) => {
  if (!object || !key) {
    return undefined;
  }

  return key.split('.').reduce((accumulator, segment) => {
    if (!accumulator || typeof accumulator !== 'object') {
      return undefined;
    }
    return accumulator[segment];
  }, object);
};

export const applyReplacements = (valueToFormat, replacements) => {
  if (typeof valueToFormat !== 'string' || !replacements || typeof replacements !== 'object') {
    return valueToFormat;
  }

  return valueToFormat.replace(/\{(\w+)\}/g, (_, token) => {
    const replacement = replacements[token];
    return replacement === undefined || replacement === null ? `{${token}}` : String(replacement);
  });
};

export const createWebTranslator = (rawLocale) => {
  const locale = normalizeLocale(rawLocale || detectDeviceLocale());
  const dictionary = DICTIONARIES[locale] || DICTIONARIES['en-US'];

  return (key, fallback = key, replacements = null) => {
    let localizedValue = resolveNestedValue(dictionary, key);
    if (typeof localizedValue !== 'string' && locale !== 'en-US') {
      localizedValue = resolveNestedValue(DICTIONARIES['en-US'], key);
    }
    const resolvedValue = typeof localizedValue === 'string' ? localizedValue : fallback;
    return applyReplacements(resolvedValue, replacements);
  };
};

export const translateWeb = (rawLocale, key, fallback = key, replacements = null) =>
  createWebTranslator(rawLocale)(key, fallback, replacements);

